/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    object, string, shape, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import Card from '@material-ui/core/Card';
// import Tab from '@material-ui/core/Tab';
import ReactMarkdown from 'react-markdown';
import { getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getLanguageName } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import GraphqlProductDetailsTabs from './GraphqlProductDetailsTabs/GraphqlProductDetailsTabs';
import pdpDictionary from '../translations/pdpTranslations.json';
import DescriptionSection from './GraphqlProductDetailsTabs/Partials/DescriptionSection';

const styles = (theme) => ({
    root: {
        marginBottom: '40px',
        background: theme.palette.white,
        [theme.breakpoints.down('600')]: {
            marginBottom: '0',
        },
    },
    appBar: {
        width: '100%',
        color: theme.palette.colorPrimary,
        margin: '0 auto',
        padding: '15px 0',
        background: theme.palette.white,
        borderBottom: `2px solid ${theme.palette.colorPrimary}`,
    },
    heading: {
        fontSize: '20px',
        textTransform: 'capitalize',
        fontWeight: '500',
        textAlign: 'center',
    },

    descriptionBlock: {
        height: '100%',
        display: 'inline-block',
        padding: '0 15px',
        fontSize: '15px',
    },
    subHeading: {
        display: 'flex',
        marginTop: '15px',
        '& h2': {
            fontSize: '16px',
            margin: '0',
        },
        '& span': {
            margin: '0 0 0 5px',
        },
    },
    longDescription: {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
            '&.plaLongDescription': {
                display: 'block',
            },
        },
    },
    longDescriptionMobile: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            '&.plaShowToggle': {
                display: 'none',
            },
        },
    },
    hidden: {
        display: 'none',
    },
    toggleDescription: {
        margin: '0 0 20px 0',
        padding: '0',
        color: '#5e3987',
        fontSize: '14px',
        fontWeight: '700',
        textDecoration: 'underline',
        border: 'none',
        cursor: 'pointer',
        background: 'none',
    },
    longDesLInks: {
        '& a': {
            color: '#65398E',
        },
    },
});

const  GraphqlProductDetailsUI = ({
    classes, partNumber,
    longDescription, isPassportBundleProduct, dataDictionary, brand,
}) => {
    const [showBundleLongDescription, setShowBundleLongDescription] = useState(false);
    const language = getLanguageName();

    if (brand.code === 'PLA') {
        return (
            <GraphqlProductDetailsTabs
                brand={brand}
                language={language}
                partNumber={partNumber}
                longDescription={longDescription}
                customClasses={classes}
                dataDictionary={dataDictionary}
                pdpDictionary={pdpDictionary}
            />
        );
    }
    return (
        <>
            <Card className={classes.root} variant="outlined">
                <AppBar
                    className={`${classes.appBar}`}
                    position="static"
                    elevation={0}
                >
                    <div className={classes.heading}>
                        {language === '/en' ? 'Description' : dataDictionary.Description}
                    </div>
                </AppBar>
                <DescriptionSection
                    brand={brand}
                    language={language}
                    partNumber={partNumber}
                    longDescription={longDescription}
                    customClasses={classes}
                    dataDictionary={dataDictionary}
                    pdpDictionary={pdpDictionary}
                />
            </Card>
            {isPassportBundleProduct?.details?.item_sku
            && (
                <Card className={classes.root} variant="outlined">
                    <div className={classes.descriptionBlock}>
                        <div className={classes.subHeading}>
                            <h2>Celebrations Passport Details</h2>: <span>{isPassportBundleProduct?.details?.item_sku}</span>
                        </div>
                        <div>
                            {/**
                             * @intention
                             * - Desktop: Always visible
                             * - Mobile: Hidden by default. Toggle visibility (read more/less)
                             */}
                            <div className={classes.longDescription}>
                                <ReactMarkdown source={isPassportBundleProduct?.details?.long_description} escapeHtml={false} />
                            </div>
                            <div className={showBundleLongDescription ? '' : classes.hidden}><ReactMarkdown source={isPassportBundleProduct?.details?.long_description} escapeHtml={false} />
                            </div>
                            <div className={classes.longDescriptionMobile}>
                                <button
                                    className={classes.toggleDescription}
                                    type="button"
                                    onClick={() => setShowBundleLongDescription(!showBundleLongDescription)}
                                >
                                    {showBundleLongDescription
                                        ? 'Read less'
                                        : 'Read more'}
                                </button>
                            </div>
                        </div>
                    </div>
                </Card>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    dataDictionary: getDataDictionary(state),
    brand: getBrand(state),
});

GraphqlProductDetailsUI.defaultProps = {
    isPassportBundleProduct: {},
};

GraphqlProductDetailsUI.propTypes = {
    classes: object.isRequired,
    partNumber: string.isRequired,
    longDescription: string.isRequired,
    isPassportBundleProduct: shape({
        enable: bool,
        prices: {},
    }),
    dataDictionary: object.isRequired,
    brand: shape({
        code: string.isRequired,
    }).isRequired,
};

export default connect(mapStateToProps)(withStyles(styles)(GraphqlProductDetailsUI));
